import { render } from "./PreloadedStatus.vue?vue&type=template&id=3b6bbafc"
import script from "./PreloadedStatus.vue?vue&type=script&lang=js"
export * from "./PreloadedStatus.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__